module.exports = __webpack_public_path__ + "static/media/captcha_icon.b644c399.svg";